
import { Component, Vue } from 'vue-property-decorator';
import Map from './Map.vue';
import DataFilter from '@/components/DataTab/DataFilter.vue';
import DataPanel from '@/components/DataTab/DataPanel.vue';

@Component({
  components: { Map, DataFilter, DataPanel },
})
export default class MapView extends Vue {
  initialY = 0;
  initialHeight = 0;
  mapContainerHeight = 0;

  // Initialize the resize event
  initResize(e: MouseEvent) {
    this.initialY = e.clientY;
    this.initialHeight = (this.$refs.dataContainer as HTMLElement).clientHeight;
    this.mapContainerHeight = (
      this.$refs.mapContainer as HTMLElement
    ).clientHeight;
    document.addEventListener('mousemove', this.resize);
    document.addEventListener('mouseup', this.stopResize);
  }
  // Resize the data container and map container
  resize(e: MouseEvent) {
    const delta = e.clientY - this.initialY;
    (this.$refs.dataContainer as HTMLElement).style.height = `${
      this.initialHeight - delta
    }px`;
    (this.$refs.mapContainer as HTMLElement).style.height = `${
      this.mapContainerHeight + delta
    }px`;
  }

  stopResize() {
    document.removeEventListener('mousemove', this.resize);
    document.removeEventListener('mouseup', this.stopResize);

    this.$emit('resize-map-view');
  }
}
